// extracted by mini-css-extract-plugin
module.exports = {"logoRound":"styles_logoRound__k9Hah","logoWithText":"styles_logoWithText__l1I6e"};